import { Container, Row, Col, Card, } from "reactstrap";
import React, { useEffect, useRef, useState } from "react";
import {
  getInitialDataRequest,
} from "../../api/controller/ManageDockController";
import echo from "../../api/core/echo";
import { handleSocket } from "../../custom/helpers/HandleSocket";
import DockingQueue from "./screensManageDock/dockingQueue";
import notify from "../../custom/helpers/Notify";
import Select from "react-select";

const ManageDock = () => {
  const [selectedZone, setSelectedZone] = useState(null);
  const [currentScreen, setCurrentScreen] = useState("initial");
  const [zones, setZones] = useState([]);
  const [dockingRequests, _setDockingRequests] = useState([]);
  const dockingRequestsRef = useRef(dockingRequests);
  const setDockingRequests = (data) => {
    dockingRequestsRef.current = data;
    _setDockingRequests(data);
  };
  
  useEffect(() => {
    setCurrentScreen("initial");
  }, [selectedZone]);

  useEffect(() => {
    async function getData() {
      const response = await getInitialDataRequest();
      if (response.Status === "error") {
        notify({
          status: "error",
          message: response.Message || "Failed to load dock data.",
        });
        return;
      }
      setZones(response.data?.zones ?? []);
      setDockingRequests(response.data?.dockingRequests ?? []);
    }

    getData();

    echo
      .private("DockingRequest-Primary")
      .listen(`.DockingRequestEvents`, (data) => {
        handleSocket(dockingRequestsRef.current, data, setDockingRequests);
      });
    return () => {
      echo.leave("DockingRequest-Primary");
    };
  }, []);

  const goToManageDock = () => {
    setCurrentScreen("initial");
  };

  const goToDockingQueue = () => {
    if (!selectedZone) {
      notify({ status: "error", message: "Please select a zone" });
    } else {
      setCurrentScreen("vesselQueue");
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container >
          {currentScreen === "initial" && (
            <div>
              {/* <h4 className="font-weight-semibold">Manage Dock</h4> */}
              <Card className="p-3">
                <h5>Select Zone</h5>
                <Row>
                  <Col className="col-md-4 col-lg-4 col-xl-3 mb-3">
                    <Select
                      className="w-100"
                      value={selectedZone}
                      placeholder="Select Zone..."
                      options={zones.map((z) => ({
                        label: z.name,
                        value: z.id,
                      }))}
                      onChange={(e) => setSelectedZone(e)}
                    />
                  </Col>
                  {selectedZone ? (
                    <Row>
                      <Col className="col-md-4 col-lg-4 col-xl-3">
                        <button
                          className="btn btn-primary fs-6 w-100 py-1 "
                          onClick={() => goToDockingQueue()}
                        >
                          <span className="me-2">Manage Zone</span>
                          <span className="mdi mdi-chevron-right align-middle fs-3"></span>
                        </button>
                      </Col>
                    </Row>
                  ) : (
                    <span className="text-center" style={{marginBottom:" 500px"}}>
                      - Please Select Zone First -
                    </span>
                  )}
                </Row>
              </Card>
              {/* {zones &&
                zones.map((item_zone, key_zone) => (
                  <Card key={key_zone} className="p-3">
                    <h4 className="font-weight-semibold">{item_zone.name}</h4>
                    {item_zone.berthing_slots.map((item_slot, key_slot) => (
                      <Card className="border mb-2" key={key_slot}>
                        <Row className="" style={{ paddingRight: "12px" }}>
                          <Col
                            className="col-8 my-2"
                            style={{ paddingLeft: "25px" }}
                          >
                            <Col>
                              <span className=" font-weight-semibold text-muted fs-6">
                                Slot:
                              </span>
                              &nbsp;&nbsp;
                              <span className="font-weight-semibold fs-6 text-primary">
                                {item_slot.name}
                              </span>
                            </Col>
                            <Col className="">
                              <span className=" font-weight-semibold text-muted fs-6">
                                Vessel:
                              </span>
                              &nbsp;&nbsp;
                              <span className="font-weight-semibold fs-6 text-primary">
                                name
                              </span>
                            </Col>
                          </Col>
                          <Col
                            className="col-4 bg-primary text-light align-middle"
                            style={{
                              borderRadius: "0px 5px 5px 0px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <div
                              className=""
                              onClick={() => goToUpdateDockingRequest()}
                            >
                              <span className="me-2">Update</span>
                              <span className="mdi mdi-chevron-right align-middle fs-3"></span>
                            </div>
                          </Col>
                        </Row>
                      </Card>
                    ))}
                  </Card>
                ))} */}
            </div>
          )}

          {currentScreen === "vesselQueue" && (
            <DockingQueue
              zones={zones}
              selectedZone={selectedZone}
              goToManageDock={goToManageDock}
              dockingRequests={dockingRequests.filter(
                (r) => r.zone_id === selectedZone.value
              )}
            />
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ManageDock;
